module.exports = __webpack_public_path__ + "static/img/zhongxiao_bg_01.2a1cf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zhongxiao_bg_01.png
// module id = H0Ba
// module chunks = 0